import {useEffect, useState} from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";

import { API_BASE } from '../config/api'

function ConfigDistribuidor() {

    const [distyNombre, setDistyNombre] = useState("");
    const [distyPassword, setDistyPassword] = useState("");
    const [distyRegionId, setDistyRegionId] = useState("");
    const [distyPlanId, setDistyPlanId] = useState("");
    const [distyImageFile, setDistyImageFile] = useState(null);

    const [regions, setRegions] = useState([]);
    const [plans, setPlans] = useState([]);

    const [showPassword, setShowPassword] = useState(false);
    const [savingDisty, setSavingDisty] = useState(false);

    const [successMessage, setSuccessMessage] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [distributors, setDistributors] = useState([]);
    const [loadingDistributors, setLoadingDistributors] = useState(false);
    const [visiblePasswords, setVisiblePasswords] = useState({});

    useEffect(() => {
        loadConfigDistyCatalogs();
        loadDistributors();
    }, []);

    const loadConfigDistyCatalogs = async () => {
        try {
            setErrorMessage("");

            const [regionsResp, plansResp] = await Promise.all([
                fetch(`${API_BASE}/api/admin/configDisty/regions`, {
                    method: "GET",
                    credentials: "include",
                }),
                fetch(`${API_BASE}/api/admin/configDisty/plans`, {
                    method: "GET",
                    credentials: "include",
                }),
            ]);

            const regionsData = await regionsResp.json();
            const plansData = await plansResp.json();

            if (!regionsResp.ok) {
                throw new Error(regionsData?.message || "No fue posible obtener las regiones");
            }

            if (!plansResp.ok) {
                throw new Error(plansData?.message || "No fue posible obtener los planes");
            }

            setRegions(regionsData.data || []);
            setPlans(plansData.data || []);
        } catch (error) {
            console.error("Error cargando catálogos de distribuidores:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar regiones y planes");
        }
    };

    const toggleDistributorPassword = (distyId) => {
        setVisiblePasswords((prev) => ({
            ...prev,
            [distyId]: !prev[distyId],
        }));
    };

    // Funcion para limpiar el modal 
    const resetAddDistyForm = () => {
    setDistyNombre("");
    setDistyPassword("");
    setDistyRegionId("");
    setDistyPlanId("");
    setDistyImageFile(null);
    setShowPassword(false);

    setSuccessMessage("");
    setInfoMessage("");
    setErrorMessage("");

    const fileInput = document.getElementById("customFile1");
        if (fileInput) fileInput.value = "";
    };

    const validateAddDistyForm = () => {
    if (!distyNombre.trim()) {
        setInfoMessage("El campo (nombre) es obligatorio");
        return false;
    }

    if (!distyPassword.trim()) {
        setInfoMessage("El campo (password) es obligatorio");
        return false;
    }

    if (!distyRegionId) {
        setInfoMessage("El campo (región) es obligatorio");
        return false;
    }

    if (!distyPlanId) {
        setInfoMessage("El campo (plan) es obligatorio");
        return false;
    }

    if (!distyImageFile) {
        setInfoMessage("Debes seleccionar una imagen");
        return false;
    }

    return true;
    };

    const uploadDistributorImage = async () => {
        if (!distyImageFile) {
            throw new Error("Debes seleccionar una imagen");
        }

        const formData = new FormData();
        formData.append("image", distyImageFile);

        const response = await fetch(`${API_BASE}/api/admin/configDistyPhoto`, {
            method: "POST",
            credentials: "include",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data?.message || "No fue posible subir la imagen");
        }

        return data?.data?.publicUrl || null;
    };

    const loadDistributors = async () => {
        try {
            setLoadingDistributors(true);
            setErrorMessage("");

            const response = await fetch(`${API_BASE}/api/admin/configDisty`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener los distribuidores");
            }

            setDistributors(data?.data || []);
        } catch (error) {
            console.error("Error al cargar distribuidores:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar distribuidores");
        } finally {
            setLoadingDistributors(false);
        }
    };

    const handleDistributorImageChange = (e) => {
        setInfoMessage("");
        setErrorMessage("");
        setSuccessMessage("");

        const file = e.target.files?.[0] || null;

        if (!file) {
            setDistyImageFile(null);
            return;
        }

        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

        if (!allowedTypes.includes(file.type)) {
            setDistyImageFile(null);
            e.target.value = "";
            setInfoMessage("Solo se permiten imágenes JPG, PNG o WEBP");
            return;
        }

        setDistyImageFile(file);
    };

    // Funcion para guardar cambios
    const handleSaveDistributor = async () => {
    try {
            setSuccessMessage("");
            setInfoMessage("");
            setErrorMessage("");

            const isValid = validateAddDistyForm();
            if (!isValid) return;

            setSavingDisty(true);

            const imageUrl = await uploadDistributorImage();

            const payload = {
                Disty_Nombre: distyNombre.trim(),
                Disty_Imagen: imageUrl,
                Disty_Region_ID: Number(distyRegionId),
                Disty_Plan_ID: Number(distyPlanId),
                Password_Default: distyPassword.trim(),
            };

            const response = await fetch(`${API_BASE}/api/admin/configDisty`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "Ocurrió un error al guardar el distribuidor");
            }

            setSuccessMessage("Distribuidor guardado correctamente");

            resetAddDistyForm();
            setSuccessMessage("Distribuidor guardado correctamente");

            // Si tienes listado de distribuidores, aquí puedes recargarlo:
            await loadDistributors();

            // Si quieres cerrar el modal automáticamente después de guardar:
            // const modalEl = document.getElementById("addDistributorModal");
            // const modalInstance = window.bootstrap?.Modal.getInstance(modalEl);
            // modalInstance?.hide();

        } catch (error) {
            console.error("Error al guardar distribuidor:", error);
            setErrorMessage(error.message || "Ocurrió un error");
        } finally {
            setSavingDisty(false);
        }
    };

    // Funcion para ver Distribuidor

    // Funcion para editar Distribuidor

    // Funcion para eliminar Distribuidor

    // Paginador

    const {
        currentPage,
        totalPages,
        totalItems,
        paginatedItems,
        visiblePages,
        startItem,
        endItem,
        goToPage,
        goToPreviousPage,
        goToNextPage,
        resetPagination,
        hasPreviousPage,
        hasNextPage,
    } = usePagination(distributors, 8, 5);

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">

                {/* Titulos */}
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Distribuidores</h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header d-flex justify-content-end gap-3">
                                
                                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addDistributorModal">
                                    <span class="btn-inner mr-5">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-24"><path d="M12 4V20M20 12H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                    Agregar
                                </button>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                <table id="datatable" class="table table-striped" data-toggle="data-table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Plan</th>
                                            <th>Contraseña</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {loadingDistributors ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                Cargando distribuidores...
                                            </td>
                                        </tr>
                                    ) : paginatedItems.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No hay distribuidores registrados
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedItems.map((disty) => {
                                            const isPasswordVisible = !!visiblePasswords[disty.Disty_ID];
                                            const safePassword = disty.Password_Default || "";
                                            const maskedPassword = safePassword ? "•".repeat(safePassword.length) : "••••••";

                                            return (
                                                <tr key={disty.Disty_ID}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            {/* <img
                                                                className="rounded img-fluid me-3"
                                                                src={disty.Disty_Imagen || "/assets/images/default-image.jpg"}
                                                                alt={disty.Disty_Nombre}
                                                                loading="lazy"
                                                                style={{width:'10%'}}
                                                            /> */}
                                                            <h6 className="mb-0">{disty.Disty_Nombre}</h6>
                                                        </div>
                                                    </td>

                                                    <td>{disty.Plan_Nombre || "-"}</td>

                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span style={{ minWidth: "100px" }}>
                                                                {isPasswordVisible ? safePassword : maskedPassword}
                                                            </span>

                                                            <button
                                                                type="button"
                                                                className="btn btn-icon btn-primary-subtle rounded-pill btn-sm"
                                                                onClick={() => toggleDistributorPassword(disty.Disty_ID)}
                                                                title={isPasswordVisible ? "Ocultar contraseña" : "Ver contraseña"}
                                                            >
                                                                {isPasswordVisible ? (
                                                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                                        <path d="M9.76045 14.3667C9.18545 13.7927 8.83545 13.0127 8.83545 12.1377C8.83545 10.3847 10.2474 8.97168 11.9994 8.97168C12.8664 8.97168 13.6644 9.32268 14.2294 9.89668" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M15.1049 12.6987C14.8729 13.9887 13.8569 15.0067 12.5679 15.2407" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6.65451 17.4722C5.06751 16.2262 3.72351 14.4062 2.74951 12.1372C3.73351 9.85823 5.08651 8.02823 6.68351 6.77223C8.27051 5.51623 10.1015 4.83423 11.9995 4.83423C13.9085 4.83423 15.7385 5.52623 17.3355 6.79123" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19.4473 8.99072C20.1353 9.90472 20.7403 10.9597 21.2493 12.1367C19.2823 16.6937 15.8063 19.4387 11.9993 19.4387C11.1363 19.4387 10.2853 19.2987 9.46729 19.0257" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M19.8868 4.24951L4.11279 20.0235" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                ) : (
                                                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1614 12.0531C15.1614 13.7991 13.7454 15.2141 11.9994 15.2141C10.2534 15.2141 8.83838 13.7991 8.83838 12.0531C8.83838 10.3061 10.2534 8.89111 11.9994 8.89111C13.7454 8.89111 15.1614 10.3061 15.1614 12.0531Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.998 19.355C15.806 19.355 19.289 16.617 21.25 12.053C19.289 7.48898 15.806 4.75098 11.998 4.75098H12.002C8.194 4.75098 4.711 7.48898 2.75 12.053C4.711 16.617 8.194 19.355 12.002 19.355H11.998Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="d-flex align-items-center gap-3">
                                                            <button
                                                                className="btn btn-info-subtle btn-sm"
                                                                type="button"
                                                                title="Editar"
                                                            >
                                                                <span className="btn-inner">
                                                                    <svg
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        className="icon-24"
                                                                    >
                                                                        <path
                                                                            d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            fillRule="evenodd"
                                                                            clipRule="evenodd"
                                                                            d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M15.1655 4.60254L19.7315 9.16854"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </button>

                                                            <button
                                                                className="btn btn-danger-subtle btn-sm"
                                                                type="button"
                                                                title="Eliminar"
                                                            >
                                                                <span className="btn-inner">
                                                                    <svg
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        className="icon-24"
                                                                    >
                                                                        <path
                                                                            d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M20.708 6.23975H3.75"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                                </table>
                                </div>
                            </div>

                            <UniversalPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                startItem={startItem}
                                endItem={endItem}
                                visiblePages={visiblePages}
                                onPageChange={goToPage}
                                onPrevious={goToPreviousPage}
                                onNext={goToNextPage}
                                hasPreviousPage={hasPreviousPage}
                                hasNextPage={hasNextPage}
                            />
                        </div>
                    </div>
                </div>

                {/* Modal para agregar distribuidor */}
                <div
                    className="modal fade"
                    id="addDistributorModal"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Agregar Distribuidor
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={resetAddDistyForm}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="nombre">
                                            Nombre:
                                        </label>
                                        <input
                                            id="nombre"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresa el nombre de distribuidor"
                                            value={distyNombre}
                                            onChange={(e) => setDistyNombre(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col">
                                        <label className="form-label" htmlFor="password">
                                            Password
                                        </label>

                                        <div className="position-relative">
                                            <input
                                                id="password"
                                                type={showPassword ? "text" : "password"}
                                                className="form-control pe-5"
                                                placeholder="Ingresa la contraseña predeterminada"
                                                value={distyPassword}
                                                onChange={(e) => setDistyPassword(e.target.value)}
                                                required
                                            />

                                            <button
                                                type="button"
                                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent shadow-none"
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{ zIndex: 5 }}
                                            >
                                                {showPassword ? (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        fill="currentColor"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M13.359 11.238 15 12.879l-.707.707-1.73-1.73A8.46 8.46 0 0 1 8 13.5c-3 0-5.5-1.833-7-5  .617-1.304 1.41-2.35 2.335-3.165L1 2.707 1.707 2l12 12-.707.707-.64-.64zM11.297 9.883l-1.532-1.532a2 2 0 0 1-2.116-2.116L6.117 4.703A3 3 0 0 0 8 11a2.98 2.98 0 0 0 1.883-.703z" />
                                                        <path d="M10.477 7.649A2 2 0 0 0 8.351 5.523l2.126 2.126zM8 3.5c3 0 5.5 1.833 7 5a8.7 8.7 0 0 1-1.935 2.707l-.708-.708A7.63 7.63 0 0 0 14 8.5c-1.305-2.611-3.305-4-6-4-.84 0-1.64.134-2.39.395l-.77-.77A8.82 8.82 0 0 1 8 3.5z" />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        fill="currentColor"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.12 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                        <path d="M8 5.5A2.5 2.5 0 1 0 8 10.5 2.5 2.5 0 0 0 8 5.5zm0 1A1.5 1.5 0 1 1 8 9.5 1.5 1.5 0 0 1 8 6.5z" />
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="region">
                                            Región:
                                        </label>
                                        <select
                                            id="region"
                                            className="form-select mb-3 shadow-none"
                                            value={distyRegionId}
                                            onChange={(e) => setDistyRegionId(e.target.value)}
                                            required
                                        >
                                            <option value="">Selecciona una Región</option>
                                            {regions.map((region) => (
                                                <option key={region.Region_ID} value={region.Region_ID}>
                                                    {region.Region_Nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col">
                                        <label className="form-label" htmlFor="plan">
                                            Plan
                                        </label>
                                        <select
                                            id="plan"
                                            className="form-select mb-3 shadow-none"
                                            value={distyPlanId}
                                            onChange={(e) => setDistyPlanId(e.target.value)}
                                            required
                                        >
                                            <option value="">Selecciona un Plan</option>
                                            {plans.map((plan) => (
                                                <option key={plan.Plan_ID} value={plan.Plan_ID}>
                                                    {plan.Plan_Nombre}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label className="form-label" htmlFor="customFile1">
                                            Selecciona una imagen:
                                        </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            id="customFile1"
                                            accept=".jpg,.jpeg,.png,.webp"
                                            onChange={handleDistributorImageChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {successMessage && (
                                    <div
                                        className="mb-3 alert alert-left alert-success alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{successMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setSuccessMessage("")}
                                        ></button>
                                    </div>
                                )}

                                {infoMessage && (
                                    <div
                                        className="mb-3 alert alert-top alert-info alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{infoMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setInfoMessage("")}
                                        ></button>
                                    </div>
                                )}

                                {errorMessage && (
                                    <div
                                        className="alert alert-bottom alert-danger alert-dismissible fade show"
                                        role="alert"
                                    >
                                        <span>{errorMessage}</span>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            data-bs-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => setErrorMessage("")}
                                        ></button>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={resetAddDistyForm}
                                    disabled={savingDisty}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSaveDistributor}
                                    disabled={savingDisty}
                                >
                                    {savingDisty ? "Guardando..." : "Guardar"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
        </>
    )
}

export default ConfigDistribuidor